module.exports = __webpack_public_path__ + "static/media/3DPPA29.93820d0d.jpg";